// extracted by mini-css-extract-plugin
module.exports = {"message":"input-message_message__q4BuL","error":"input-message_error__TuKXb","success":"input-message_success__eeMrV","normal":"input-message_normal__XLC4O"};